import React from 'react';
import DataRights from '../components/signin/DataRights';

const SigninPrivacyDataRights = () => {
  return <DataRights />;
};

export default SigninPrivacyDataRights;
